import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { PageTitle } from '../../common/components/PageTitle';

const BookingThankYou = () => {
    const { t } = useTranslation();
    const location = useLocation();

    // Use router state first, fall back to sessionStorage on page reload
    const hasPriceCalculated = location.state?.hasPriceCalculated 
        ?? sessionStorage.getItem('thankYouHasPriceCalculated') === 'true';
    const translationKey = hasPriceCalculated
        ? 'booking.thanksWithPrice'
        : 'booking.thanksPriceOnRequest';

    return (
        <>
            <PageTitle sx={{ pt: 8 }}>{t(`${translationKey}.title`)}</PageTitle>
            <Box sx={(theme) => theme.mixins.box(theme)}>
                <Box sx={{ pt: 0.5, pb: 1 }}>
                    <Typography variant="h5" sx={{ mb: 3, textAlign: 'center' }}>
                        {t(`${translationKey}.title2`)}
                    </Typography>
                    <Typography variant="body1">{t(`${translationKey}.itemsTitle`)}</Typography>
                    <ol>
                        <Typography variant="body1" component="li" sx={{ mb: 1 }}>
                            {t(`${translationKey}.item1`)}
                        </Typography>
                        <Typography variant="body1" component="li" sx={{ mb: 1 }}>
                            {t(`${translationKey}.item2`)}
                        </Typography>
                        <Typography variant="body1" component="li" sx={{ mb: 1 }}>
                            {t(`${translationKey}.item3`)}
                        </Typography>
                    </ol>
                </Box>
            </Box>
        </>
    );
};

export { BookingThankYou };
